import { render, staticRenderFns } from "./MemberExclusions.vue?vue&type=template&id=4e73d2f7"
import script from "./MemberExclusions.vue?vue&type=script&lang=js"
export * from "./MemberExclusions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports